module.exports = __webpack_public_path__ + "img/help.a3cc61aa.png";